import { render, staticRenderFns } from "./ProductDirectory.vue?vue&type=template&id=24436555&scoped=true&"
import script from "./ProductDirectory.vue?vue&type=script&lang=ts&"
export * from "./ProductDirectory.vue?vue&type=script&lang=ts&"
import style0 from "./ProductDirectory.vue?vue&type=style&index=0&id=24436555&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24436555",
  null
  
)

export default component.exports